import { useState, useCallback } from "react";
import AddIcon from "@mui/icons-material/Add";
import CardPedidoRetireNaLoja from "./CardPedidoRetireNaLoja";
import { IconButton } from "@material-ui/core";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import {
  columnTextField,
  columnPriceField,
  columnDateField,
} from "utils/tables-utils";

export default function TableRetireNaLoja({
  dataTable,
  search,
  currentSizePerPage,
  currentPage,
  totalRegistros,
  autoSearch,
  statusConsulta,
  setRefreshPage,
}) {
  const [loading, setLoading] = useState(false);
  const [pedidoSelecionado, setPedidoSelecionado] = useState(null);

  const handleSelectOrder = (data) => {
    setPedidoSelecionado({
      ...data,
      ...data.Itens.find(
        (pedido) => pedido.IdAtendimentoApp === data.IdAtendimentoApp
      ),
    });
  };

  const showMenu = (cell, row) => {
    return (
      <div>
        <IconButton
          variant="contained"
          size="small"
          style={{ padding: "0px" }}
          title={"Mais detalhes do pedido " + row.IdPedido}
          onClick={() => handleSelectOrder(row)}
        >
          <AddIcon />
        </IconButton>
      </div>
    );
  };

  const columnModel = [
    {
      dataField: "menu",
      text: "  ",
      isDummyField: true,
      formatter: showMenu,
      csvExport: false,
    },
    columnTextField({
      dataField: "Apelido",
      text: "Loja",
      align: "left",
    }),
    columnTextField({
      dataField: "IdPedido",
      text: "Pedido",
      align: "center",
    }),
    columnDateField({
      dataField: "DataPedido",
      text: "Data Pedido",
      align: "center",
    }),
    columnTextField({
      dataField: "StatusDescricao",
      text: "Status E-commerce",
      align: "center",
    }),
    columnTextField({
      dataField: "Status",
      text: "Status Retirada",
      align: "center",
    }),
    columnDateField({
      dataField: "DataPrevisaoEntrega",
      text: "Data Entrega",
      align: "center",
    }),
    columnPriceField(
      {
        dataField: "ValorTotalPedido",
        text: "Valor Total",
      },
      false
    ),
    columnTextField({
      dataField: "NomeCliente",
      text: "Nome Cliente",
      align: "center",
    }),
  ];

  const doSearch = useCallback(
    async (page, sizePerPage) => {
      setLoading(true);
      await search({ page, sizePerPage, urlStatus: statusConsulta });
      setLoading(false);
    },
    [statusConsulta]
  );

  const handlePageChange = useCallback(
    (page, sizePerPage) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  const handleSizePerPageChange = useCallback(
    (sizePerPage, page) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  return (
    <>
      {pedidoSelecionado !== null ? (
        <CardPedidoRetireNaLoja
          key={pedidoSelecionado?.IdPedido}
          dataOrder={pedidoSelecionado}
          dataTable={pedidoSelecionado?.Itens}
          statusConsulta={statusConsulta}
          autoSearch={autoSearch}
          setPedidoSelecionado={setPedidoSelecionado}
          setRefreshPage={setRefreshPage}
        />
      ) : (
        <ToolkitTable
          searched={Boolean(dataTable)}
          keyField="IdPedido"
          dataTable={dataTable}
          columnModel={columnModel}
          headerTitle="Retire na Loja"
          styledRow={{
            cursor: "pointer",
          }}
          onRowClick={(_, row) => handleSelectOrder(row)}
          pagination={{
            options: [25, 50, 100],
            defaultOption: currentSizePerPage,
            totalSize: totalRegistros,
            showTotal: true,
            page: currentPage,
            onPageChange: handlePageChange,
            sizePerPage: currentSizePerPage,
            onSizePerPageChange: handleSizePerPageChange,
          }}
          loading={loading}
          notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
          bootstrapTableProps={{
            remote: true,
            onTableChange: () => {},
          }}
          csvFileName="pedidos-retire-na-loja"
          csvExport
        />
      )}
    </>
  );
}
